export default (str, success, error) => {
  try {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    // node.select();
    // node.setSelectionRange(0, 99999);
    // document.execCommand('copy');
    success();
  } catch (e) {
    error(e);
  }
};

export const copyToClipboard = async value => {
  await navigator.clipboard.writeText(value);
};
